<app-dialog
  #dialog
  [key]="'confirm-liquidation-operation'"
  [action]="'confirm-liquidation-operation'"
  [headerTheme]="'simple'"
  [title]="'Confirmar Liquidação da Operação'"
  [maxWidth]="'760px'">
  <div class="confirm-liquidation" *ngIf="data">
    <p class="intro">
      Você está prestes a liquidar esta operação com os valores abaixo. Após confirmar, a liquidação
      será efetivada e refletida no status financeiro da operação.
    </p>

    <div class="summary-grid">
      <div class="summary-item">
        <span class="label">Data da liquidação</span>
        <span class="value">{{ data.settlementDate }}</span>
      </div>
      <div class="summary-item">
        <span class="label">Notional da liquidação</span>
        <span class="value">{{ data.settlementNotional }}</span>
      </div>
      <div class="summary-item">
        <span class="label">Spot</span>
        <span class="value">{{ data.settlementSpot }}</span>
      </div>
      <div class="summary-item">
        <span class="label">Taxa de liquidação</span>
        <span class="value">{{ data.settlementRate }}</span>
      </div>
    </div>

    <div class="financial-grid">
      <div class="financial-item">
        <span class="label">Ajuste bruto</span>
        <span class="value">{{ data.totalAmount | vaultFormatCurrency: 2 }}</span>
      </div>
      <div class="financial-item">
        <span class="label">IRRF</span>
        <span class="value">{{ data.withholdingTax | vaultFormatCurrency: 2 }}</span>
      </div>
      <div class="financial-item">
        <span class="label">IR a pagar</span>
        <span class="value">{{ data.incomeTaxPayable | vaultFormatCurrency: 2 }}</span>
      </div>
      <div class="financial-item">
        <span class="label">Ajuste líquido</span>
        <span class="value">{{ data.netAmount | vaultFormatCurrency: 2 }}</span>
      </div>
    </div>

    <div class="impact-box">
      <div class="impact-title">Ao confirmar, o sistema irá:</div>
      <ol>
        <li>Efetivar a liquidação com data, taxa, spot e notional informados.</li>
        <li>Atualizar o status financeiro/composição conforme liquidação integral ou parcial.</li>
        <li>Registrar ajuste bruto, impostos e ajuste líquido no histórico da operação.</li>
      </ol>
    </div>
  </div>

  <ng-template #footer>
    <div class="confirmation-footer">
      <app-button [theme]="'white'" [label]="'Cancelar'" (sendButtonClick)="close()"> </app-button>
      <app-button [label]="'Confirmar Liquidação'" (sendButtonClick)="handleConfirm()">
      </app-button>
    </div>
  </ng-template>
</app-dialog>
